module.exports = __webpack_public_path__ + "img/bago.a91a7581.jpg";